export default __webpack_public_path__ + "static/media/server-error.edb64fed.svg";